import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rocket16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5 4.5C12.5 5.05228 12.0523 5.5 11.5 5.5C10.9477 5.5 10.5 5.05228 10.5 4.5C10.5 3.94772 10.9477 3.5 11.5 3.5C12.0523 3.5 12.5 3.94772 12.5 4.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.29804 2.14124C10.6196 0.819652 12.2625 0.75 13.9999 0.75C14.6903 0.75 15.2499 1.30964 15.2499 2C15.2499 3.73747 15.1803 5.38031 13.8587 6.7019L12.2499 8.31077V13.0858C12.2499 14.6449 10.3649 15.4257 9.2625 14.3232L7.12521 12.1859C6.71856 13.6641 5.36477 14.75 3.75736 14.75H1.25V12.2426C1.25 10.6352 2.33586 9.28144 3.81407 8.87479L1.67672 6.73744C0.574277 5.635 1.35507 3.75 2.91415 3.75H7.68928L9.29804 2.14124ZM5.31066 8.25006L10.3587 3.2019C11.3112 2.24938 12.5048 2.25 13.7499 2.25C13.7499 3.49516 13.7506 4.68872 12.798 5.64124L11.1161 7.32322L11.1061 7.3333L7.75 10.6894C6.93688 9.87628 6.12377 9.06317 5.31066 8.25006ZM4.74264 10.25C3.64214 10.25 2.75 11.1421 2.75 12.2426V13.25H3.75736C4.88285 13.25 5.75 12.3113 5.75 11.2071C5.75 10.6515 5.28203 10.25 4.74264 10.25ZM6.18939 5.25H2.91415C2.69143 5.25 2.57989 5.51929 2.73738 5.67678L4.25 7.1894L6.18939 5.25ZM10.3232 13.2626L8.81066 11.7501L10.7499 9.81077V13.0858C10.7499 13.3085 10.4807 13.4201 10.3232 13.2626Z'
      fill='currentColor'
    />
  </Svg>
);

Rocket16.displayName = 'Rocket16';
export default Rocket16;
